/*
  Это трансформация легаси параметров интернет магазина в формат параметров, которые принимает текущее API
*/
import type { Context } from '@nuxt/types'

export default function transformQueryParam({ query, path }: { query: Context['query']; path: Context['route']['path'] }) {
  const q = { ...query }
  const page = q.PAGEN_1
  const sort = q.sort
  const availabilitySort = !!q.availability_sort
  const bonusFrom = q.bonusFrom
  const filterGroups = q.filterGroups
  const mode = q.mode
  delete q.PAGEN_1
  delete q.sort
  delete q.availability_sort
  delete q.bonusFrom
  delete q.filterGroups
  delete q.mode

  const params = {
    // Для страницы скидок нам нужен параметр categoryID, а для каталога route.path
    ...(+query?.categoryID ? { sectionID: +query?.categoryID } : { seo: path }),
    page: +page > 1 ? +page : undefined,
    sort,
    availabilitySort,
    size: 60,
    bonusFrom,
    filterGroups,
    mode,
    customQuery: { ...q },
  }
  return params
}
